import { render, staticRenderFns } from "./FttbWizard.vue?vue&type=template&id=8e637fbe&"
import script from "./FttbWizard.vue?vue&type=script&lang=js&"
export * from "./FttbWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports